export default {
  LIST (state, value) {
    state.list = value && Array.isArray(value) ? value : []
  },
  CURRENT (state, value) {
    for (const attr of Object.keys(state.current)) {
      state.current[attr] = value[attr]
    }
  },
  LIST_ADD (state, value) {
    if (state.list.findIndex((i) => i.id === value.id) === -1) {
      state.list.push({
        createdAt: value.createdAt,
        id: value.id,
        method: value.method,
        result: value.result,
        searchConfig: value.searchConfig,
        status: value.status,
        meta: value.meta
      })
    }
  },
  LIST_REMOVE (state, value) {
    const index = state.list.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.list.splice(index, 1)
    }
  },
  LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.list.splice(index, 1, {
        createdAt: value.createdAt,
        id: value.id,
        method: value.method,
        result: value.result,
        searchConfig: value.searchConfig,
        status: value.status,
        meta: value.meta
      })
    }
  },
  MANUAL_SCANS (state, value) {
    state.manual_scans = value
  }
}
